/**
 * Dados e tokens do mockup de atendimento.
 * Cores = tokens do tema dark do sistema real (evolzap/frontend/src/index.css)
 * e valores fixos usados em /novo-chat/chat. Todos os dados sao ficticios.
 */

export const CORES = {
  fundo: "#0A0A0A", // --background
  card: "#0F0F0F", // --card
  muted: "#171717", // --muted
  borda: "#2E2E2E", // --border
  texto: "#F3F4F6", // --foreground
  textoMuted: "#9A9DA5", // --muted-foreground
  primary: "#5B8DEF", // --primary
  azulAtivo: "#0066FF", // aba ativa / novo contato
  vermelhoContador: "#FF4444", // contador das abas
  outlineAtivo: "#93c5fd", // conversa selecionada
  balaoRecebido: "#202C33",
  balaoRecebidoBorda: "#2A3942",
  balaoEnviado: "#005C4B",
  balaoTexto: "#E9EDEF",
};

// Paleta usada no avatar de iniciais do sistema real.
const PALETA_AVATAR = [
  "#ef4444", "#f97316", "#f59e0b", "#eab308", "#84cc16", "#22c55e",
  "#10b981", "#14b8a6", "#06b6d4", "#0ea5e9", "#3b82f6", "#6366f1",
  "#8b5cf6", "#a855f7", "#d946ef", "#ec4899", "#f43f5e",
];

export function corDoNome(nome) {
  let h = 0;
  for (let i = 0; i < nome.length; i++) h = (h * 31 + nome.charCodeAt(i)) >>> 0;
  return PALETA_AVATAR[h % PALETA_AVATAR.length];
}

export function iniciais(nome) {
  const partes = nome.trim().split(/\s+/);
  return ((partes[0]?.[0] || "") + (partes[1]?.[0] || "")).toUpperCase();
}

// O sistema mostra so as 3 primeiras palavras da ultima mensagem.
export function preview(texto) {
  const palavras = texto.split(/\s+/);
  return palavras.length > 3 ? `${palavras.slice(0, 3).join(" ")}...` : texto;
}

export const CONVERSAS = [
  { nome: "Carlos Mendes", canal: "whatsapp", msg: "Claro! Vou enviar o catálogo para você.", hora: "17:31", ativo: true },
  { nome: "Fernanda Lima", canal: "instagram", msg: "Qual o prazo de entrega?", hora: "17:12", naoLidas: 2 },
  { nome: "Rafael Silva", canal: "facebook", msg: "Consegue me enviar o orçamento?", hora: "16:48", naoLidas: 1 },
  { nome: "Juliana Costa", canal: "telegram", msg: "Obrigada pelo atendimento!", hora: "16:20" },
  { nome: "Lucas Almeida", canal: "webchat", msg: "Vocês entregam no meu bairro?", hora: "15:37" },
  { nome: "Mariana Souza", canal: "whatsapp", msg: "Pode confirmar o meu pedido?", hora: "14:05", naoLidas: 3 },
  { nome: "Pedro Henrique", canal: "instagram", msg: "Perfeito, muito obrigado!", hora: "11:37" },
];

export const ATENDENTE = "Ana Paula";

export const MENSAGENS = [
  { de: "cliente", hora: "17:20", texto: "Boa tarde, vocês têm esse produto disponível?" },
  { de: "atendente", hora: "17:22", texto: "Olá, Carlos! Temos sim. Posso te enviar o catálogo com os modelos e valores?" },
  { de: "cliente", hora: "17:28", texto: "Ótimo! Pode me enviar, por favor?" },
  { de: "atendente", hora: "17:31", texto: "Claro! Vou enviar o catálogo para você.", link: "evolzap.online/c/loja-exemplo" },
];

export const CLIENTE = {
  nome: "Carlos Mendes",
  pedidos: "3 pedidos",
  telefone: "(11) 90000-0000",
  endereco: "Rua das Flores, 120 — Centro",
  ultimoPedido: "#1048 · ontem, 19:40",
};
